export default __webpack_public_path__ + "static/media/RobotoMono-Italic.a6315cb5.woff2";